import ErrorPopup from "./Popup"

export default  ErrorPopup;
